import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=4efd3a8a&scoped=true&"
import script from "./TheLogo.vue?vue&type=script&lang=js&"
export * from "./TheLogo.vue?vue&type=script&lang=js&"
import style0 from "./TheLogo.vue?vue&type=style&index=0&id=4efd3a8a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd3a8a",
  null
  
)

export default component.exports